import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: 'Hello!',
  ProductCode: 'mfq48',
  Description:
    'Try some of the online revision included with our Maths Exam Practice Workbooks. Get full access to all the features when you buy your book and unlock CGP RevisionHub with the unique code printed inside!',
  Credits:
  '<i> <br /> Clipart from Corel®</i>' +
    '<i> <br /> <br />Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',
  FreeSampleContent:
    '<p>This is a free sample of the CGP RevisionHub for GCSE Maths. <a href="[[external_domain]]/secondary-books/gcse/cgp-revisionhub" class="link-button" style="color: #FF9335;">Order</a> your book now for full access to online Maths revision.</p>',};